export default __webpack_public_path__ + "static/players-a062573c7541d8d1b3dc083f0eec4384.png";